import type { CSSProperties } from 'preact'

import { uiTokens } from '#src/assets/ui/shared/styles.ts'

export function ToggleSwitch({
  checked,
  disabled,
  onChange,
}: {
  checked: boolean
  disabled?: boolean
  onChange?: (checked: boolean) => void
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      style={{
        ...trackBaseStyle,
        background: checked
          ? disabled
            ? uiTokens.colors.toggleTrackDisabled
            : uiTokens.colors.buttonDark
          : uiTokens.colors.toggleTrackOff,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: 1,
      }}
      onClick={event => {
        event.stopPropagation()
        if (!disabled && onChange) {
          onChange(!checked)
        }
      }}
    >
      <span
        style={{
          ...thumbStyle,
          left: checked ? '26px' : '2px',
        }}
      >
        {checked ? '✓' : '✕'}
      </span>
    </button>
  )
}

const trackBaseStyle: CSSProperties = {
  position: 'relative',
  width: '52px',
  height: '28px',
  borderRadius: '999px',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
  flexShrink: 0,
  transition: 'background-color 0.2s ease',
}

const thumbStyle: CSSProperties = {
  position: 'absolute',
  top: '2px',
  width: '24px',
  height: '24px',
  borderRadius: '50%',
  background: uiTokens.colors.white,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'left 0.2s ease',
  fontSize: '12px',
  fontWeight: '700',
  color: uiTokens.colors.gray500,
}
